export default __webpack_public_path__ + "static/media/ali-mazhar-fitness.2c747bfe.jpeg";